import { render } from "./CardFlip.vue?vue&type=template&id=06047df8&scoped=true"
import script from "./CardFlip.vue?vue&type=script&lang=js"
export * from "./CardFlip.vue?vue&type=script&lang=js"

import "./CardFlip.vue?vue&type=style&index=0&id=06047df8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06047df8"]])

export default __exports__